import {Box, Button, Paper, Stack, Typography} from "@mui/material";
import React, {useCallback, useState} from "react";
import {getPatients as dowloadDocs} from "../http/reportsAPI";
import {exportToExcel} from "react-json-to-excel";
import useSnackbar from "../hooks/useSnackbar";
import MySnackbar from "../components/MySnackbar";
import PatientCard from "../components/PatientCard/PatientCard";
import {getPatients} from "../http/patientAPI";
import {useNavigate} from "react-router-dom";

import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css';

const Patients = () => {
    const snack = useSnackbar(false, "Ошибка");
    const [phone, setPhone] = useState("");
    const [patients, setPatients] = useState([]);
    const navigate = useNavigate();
    // Fetch patient information by phone number
    const handleClickGetPatientInfo = useCallback(async () => {
        try {
            const localNumber = phone.replace('+7', '8'); // Извлекаем номер без кода
            const result = await getPatients(localNumber);
            setPatients(result);
        } catch (err) {
            setPatients([]);
        }
    }, [phone]);

    // Download data as CSV
    const download = (filename, text) => {
        const element = document.createElement("a");
        element.href = `data:text/csv;charset=utf-8,${encodeURIComponent(text)}`;
        element.download = filename;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    // Convert JSON to CSV
    const jsonToCsv = (items) => {
        const header = Object.keys(items[0]).join(",");
        const rows = items.map((row) =>
            Object.values(row)
                .map((value) => JSON.stringify(value ?? ""))
                .join(",")
        );
        return [header, ...rows].join("\r\n");
    };

    // Generate and download CSV
    const generateAndDownload = async () => {
        const data = await dowloadDocs();
        download("пациенты.csv", jsonToCsv(data));
    };

    // Download data as XLSX
    const downloadXLSX = async () => {
        const data = await dowloadDocs();
        exportToExcel(data, "пациенты.xlsx");
    };

    // Обработчик для преобразования 8 в +7 при вставке
    const handleChange = (value) => {
        if (value && value.startsWith('8')) {
            setPhone('+7' + value.slice(1)); // Преобразуем 8 в +7
        } else if (value && !value.startsWith('+7')) {
            setPhone('+7' + value);
        } else {
            setPhone(value);
        }
    };

    return (
        <Stack spacing={2}>
            <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-evenly"}
                width={"100%"}
                sx={{p: 1}}
            >
                <MySnackbar {...snack} />

                <Paper
                    elevation={3}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 2,
                        m: 1,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Информация о рефералах
                    </Typography>

                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => navigate("/patients/reports")}
                            sx={{m: 1}}
                        >
                            Перейти на страницу
                        </Button>
                    </Box>
                </Paper>

                <Paper
                    elevation={3}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 2,
                        m: 1,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Введите номер для поиска пациента
                    </Typography>

                    <Box>
                        <PhoneInput
                            value={phone}
                            onChange={handleChange}
                            placeholder={"8 (___) ___-__-__"}
                            defaultCountry="RU" // Указываем Россию как единственную страну
                            international={false} // Отключаем международный формат
                            countrySelectProps={{disabled: true}} // Блокируем выбор страны
                            countryOptions={['RU']} // Ограничиваем выбор только Россией
                            displayInitialValueAsLocalNumber={true}
                        />
                        {/*<TextField*/}
                        {/*    label="Номер телефона"*/}
                        {/*    variant="outlined"*/}
                        {/*    value={phone}*/}
                        {/*    onChange={}*/}
                        {/*/>*/}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleClickGetPatientInfo}
                            sx={{m: 1}}
                        >
                            Поиск пациента
                        </Button>
                    </Box>
                </Paper>

                <Paper
                    elevation={3}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 2,
                        m: 1,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Выгрузка данных о пользователях
                    </Typography>

                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={downloadXLSX}
                            sx={{mr: 1}}
                        >
                            Скачать XLSX
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={generateAndDownload}
                        >
                            Скачать CSV
                        </Button>
                    </Box>
                </Paper>
            </Box>
            <Stack spacing={4} direction={"row"}>
                {patients.length > 0 &&
                    patients.map((patient, index) => (
                        <PatientCard
                            key={patient.id}
                            patient={patient}
                            handleClickGetPatientInfo={handleClickGetPatientInfo}
                        />
                    ))}
            </Stack>

        </Stack>
    );
};

export default Patients;
